<!-- 翻车机设备 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '设备编码',
            prop: 'deviceCode',
            search: true,
            rules: [
              {
                required: true,
                message: "请输入设备编码",
                trigger: "blur",
              },
            ],
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            rules: [
              {
                required: true,
                message: "请输入设备名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: '安装位置',
            prop: 'location',
            maxlength: 50,
            type: "textarea",
            span: 24,
            minRows: 3,
          },
          {
            label: '备注',
            prop: 'remark',
            maxlength: 50,
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: "协议类型",
            prop: "protocolType",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=protocol_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            // rules: [
            //   {required: true, message: '请选择协议类型', trigger: 'change'}
            // ],
          },
          {
            label: 'IP地址',
            prop: 'ipAddress',
          },
          {
            label: '端口号',
            prop: 'port',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
          },
          {
            label: '访问密钥',
            prop: 'accessKey',
            type: "textarea",
            span: 24,
            minRows: 3,
          },
          {
            label: "连接状态",
            prop: "connectionStatus",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=connection_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择连接状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '最后更新时间',
            prop: 'lastUpdateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            value: this.getCurrentDateTimeString(),
          },
          {
            label: '标准作业时长(秒)',
            prop: 'standardDuration',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            value: 0 // 默认值0
          },
          {
            label: '环节标准时长配置',
            prop: 'phaseStandards',
            type: "textarea",
            span: 24,
            minRows: 3,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: false
          },
        ]
      },
    }
  },
  methods: {
    /**
     * 获取当前日期时间的字符串（yyyy-MM-dd HH:mm:ss格式）
     */
    getCurrentDateTimeString() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /**
     * 在打开对话框前设置默认值
     */
    beforeOpen(done, type) {
      if (type === 'add') {
        // 新增时设置默认值
        this.$nextTick(() => {
          this.form.lastUpdateTime = this.getCurrentDateTimeString();
        });
      }
      done();
    },
  }
}
</script>
<style scoped lang="scss">
</style>
